import React from 'react';
import { useParams } from 'react-router';
import './ProjectDetails.css'
import Button from '@mui/material/Button';
import ProjectDetails from './../../Data/ProjectDetails';

const SingleProjectDetails = () => {
    let {id} = useParams();
    let projectDetail = ProjectDetails.find(s=>s.id===id)
    return (
        <div className='container mt-5'>
            <div className='row d-flex justify-content-center'>
                <div className='col-md-8'>
                    <h3 className='fw-bold border-bottom '> Project Name: {projectDetail.projectName} </h3>
                    <p className='project-des mt-3'> {projectDetail.description} </p>
                    <h4 className='fw-bold'> Features:  </h4>
                    <ul className='featuresList'>
                        <li> {projectDetail.featureOne} </li>
                        <li> {projectDetail.featureTwo} </li>
                        <li> {projectDetail.featureThree}</li>
                        <li> {projectDetail.featureFour} </li>
                        <li> {projectDetail.featureFive} </li>
                        <li> {projectDetail.featureSix} </li>
                    </ul>
                    <h4> Technology:  </h4>
                    <ul>
                        <li> {projectDetail.technology} </li>
                    </ul>

                    <a href={projectDetail.liveSite} className='codeLink' target="_blank" rel="noreferrer"><Button color="success" variant="contained">Live Site</Button> 
                    </a>
                    <a href={projectDetail.githubCode} className='codeLink' target="_blank" rel="noreferrer"> <Button color='secondary' variant="contained">Github Code</Button> 
                    </a>
                    <a href={projectDetail.gitHuBack} className='codeLink' target="_blank" rel="noreferrer"> <Button variant="contained">Backaend Code
                    </Button> 
                    </a>

                    <h4 className='fw-bold mt-4 border-bottom'> Project Images:  </h4>
                        <div id="carouselExampleControls" className="carousel slide mt-3" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <img src={projectDetail.imageOne} className="d-block w-100" alt="..."/>
                            </div>
                            <div className="carousel-item">
                            <img src={projectDetail.imageTwo} className="d-block w-100" alt="..."/>
                            </div>
                            <div className="carousel-item">
                            <img src={projectDetail.imageThree} className="d-block w-100" alt="..."/>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                        </div>
                    
                </div>
            </div>
        </div>
    );
};

export default SingleProjectDetails;

